
import Detector from '../../utils/detector';
const isApp = Detector.browser.tantutravel;

export function Webp(image){
  if(isApp){
    image = `${image}/format/webp`;
  }

  return image;
}



/**
 * 获取最原本的图片url，如果有其他裁剪参数，切掉
 * @param {*} url 
 */
export function resloveUrl(url){
  let checkImg = isSupportHttpsImg(url);
  if(checkImg){
    if(url.indexOf('.jpg!/') > -1){
      url = `${url.split('.jpg!/')[0]}.jpg!`;
    }
  }
  return url;
}



const RE_CDN_DOMAIN = /imgcdn(\d+).zuzuche.com/;
function isSupportHttpsImg(url) {
  return url && RE_CDN_DOMAIN.test(url);
}



// WEBPACK FOOTER //
// ./src/components/Poi2/formateImage.js